import { ReferralApi } from '../../generated/api';
import configuration from './configuration';

export default new ReferralApi(configuration);
